const ShutterIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #4d4d4d;
        }
        .cls-2 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-3 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          fill: #fbfbfb;
        }
      `}</style>
    </defs>

    <g>
      <circle className="cls-1" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-2" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path
        className="cls-4"
        d="M208.32,442.22v-115.78c-1.56-.88-2.05-1.39-2.56-1.42-19.07-1.09-20.19-2.29-20.2-21.81,0-25.67-.02-51.35,0-77.02.01-10.88,5.88-16.67,16.48-16.67,129.25,0,258.49-.02,387.74-.04,14.29,0,19.58,5.18,19.61,19.26.06,25.67.17,51.35.15,77.02,0,15.6-1.91,17.52-17.34,18.34-1.14.06-2.28.24-4.24.45,0,9.88-.02,19.7,0,29.53.14,69.73.31,139.46.4,209.19.02,17.41-4.98,22.32-22.14,22.32-112.62,0-225.24,0-337.86.02-13.42,0-19.84-6.73-19.94-21.73-.19-27.72-.09-55.43-.11-83.15,0-12.54,0-25.09,0-38.51Zm372.76-172.54v-29.06H215.78v51.82h365.3v-22.76Zm-343.92,261.04v24.8h320.71v-41.01H238.16v16.21Zm125.17-111.27h195.54v-34.12H238.66v34.12h124.67Zm86.13,30.65h-210.71v33.53h320.29v-33.53c-36.26,0-72.08,0-109.59,0Zm-75.62-95.48h184.54v-31.49H238.65v31.49h135.19Z"
      />
    </g>
  </svg>
);

export default ShutterIcon;